export const APP_STORE_DOWNLOAD_LINKS = {
  appleAppStoreLink: 'https://apps.apple.com/gb/app/second-nature/id885435960',
  googlePlayStoreLink:
    'https://play.google.com/store/apps/details?id=uk.co.ourpath.android&hl=en_GB',
};
